import { Module } from '@nestjs/common';
import { APP_GUARD } from '@nestjs/core';
import { PassportModule } from '@nestjs/passport';

import { JwtAuthGuard, RolesGuard } from './guards';
import { ClerkService } from './services';
import { JwtStrategy } from './strategies';

@Module({
  exports: [ClerkService],
  imports: [PassportModule.register({ defaultStrategy: 'jwt' })],
  providers: [{ provide: APP_GUARD, useClass: JwtAuthGuard }, { provide: APP_GUARD, useClass: RolesGuard }, ClerkService, JwtStrategy],
})
export class AuthModule {}
